import { defineComponent as _, inject as E } from "vue";
import { selectKey as O } from "./index676.js";
import { isArray as o, isString as m, isFunction as y } from "./index575.js";
import b from "./index712.js";
var x = _({
  name: "ElOptions",
  setup(g, { slots: r }) {
    const t = E(O);
    let u = [];
    return () => {
      var a, c;
      const i = (a = r.default) == null ? void 0 : a.call(r), n = [];
      function e(d) {
        o(d) && d.forEach((l) => {
          var s, f, p, h;
          const v = (s = l?.type || {}) == null ? void 0 : s.name;
          v === "ElOptionGroup" ? e(
            !m(l.children) && !o(l.children) && y((f = l.children) == null ? void 0 : f.default) ? (p = l.children) == null ? void 0 : p.default() : l.children
          ) : v === "ElOption" ? n.push((h = l.props) == null ? void 0 : h.value) : o(l.children) && e(l.children);
        });
      }
      return i.length && e((c = i[0]) == null ? void 0 : c.children), b(n, u) || (u = n, t && (t.states.optionValues = n)), i;
    };
  }
});
export {
  x as default
};
